import { Card } from "@/shared/components/ui/card"

export function DerechosReservadosPage() {
  return (
    <div className="pt-32 pb-20 lg:pt-40 lg:pb-32">
      <div className="container mx-auto px-4 lg:px-8 max-w-8xl">
        <h1 className="text-4xl lg:text-6xl font-bold mb-8">Derechos Reservados Rapyfact</h1>

        <Card className="p-8 lg:p-12 space-y-8">
          <section className="space-y-4">
            <h2 className="text-3xl font-bold">Copyright © 2025 Valerosas Tech S.A.S - Rapyfact</h2>
            <p className="text-xl-foreground leading-relaxed">
              Todos los derechos reservados. El contenido de este sitio web, incluyendo pero no limitado a textos,
              gráficos, logotipos, iconos, imágenes, clips de audio, descargas digitales y compilaciones de datos, es
              propiedad de Valerosas Tech S.A.S o de sus proveedores de contenido y está protegido por las leyes
              colombianas e internacionales de derechos de autor.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-3xl font-bold">Marca Registrada</h2>
            <p className="text-xl-foreground leading-relaxed">
              Rapyfact y el logotipo de Rapyfact son marcas registradas de Valerosas Tech S.A.S. Todas las demás marcas
              comerciales que aparecen en este sitio son propiedad de sus respectivos dueños.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-3xl font-bold">Uso Autorizado</h2>
            <p className="text-xl-foreground leading-relaxed">
              Queda prohibida la reproducción, distribución, modificación o uso comercial del contenido sin autorización
              expresa por escrito de Valerosas Tech S.A.S.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-3xl font-bold">Contacto</h2>
            <p className="text-xl-foreground leading-relaxed">
              Para solicitudes de uso o permisos, contacte a:
              <br />
              Email: soporte@rapyfact.com
              <br />
              Teléfono: +57 3135909091
            </p>
          </section>
        </Card>
      </div>
    </div>
  )
}
